export function clickOutsideSelector(event, selector) {
    return !event.target.closest(selector);
}
